import { AfterViewInit, Component, computed, effect, ElementRef, input, model, output, viewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-digit-code',
  imports: [FormsModule],
  templateUrl: './digit-code.component.html',
})
export class DigitCodeComponent implements AfterViewInit {
  code = model<string>('');
  length = input(6);
  label = input<string>();
  inputs = viewChildren<ElementRef<HTMLInputElement>>('inputs');
  digits = computed(() => this.computeInputs(this.code(), this.length()));
  completed = output<string>();

  constructor() {
    effect(() => {
      if (this.code() === '') this.inputs()[0]?.nativeElement.focus();
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.focusFirstEmptyInput();
    });
  }

  onKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter') return;
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  onInput(event: Event, index: number) {
    const digit = (event.target as HTMLInputElement).value || ' ';
    this.code.update(code => code.substring(0, index) + digit + code.substring(index + 1));
    if (digit !== ' ') this.focusFirstEmptyInput();
    this.emitWhenComplete();
  }

  onPaste(event: ClipboardEvent) {
    const clipboardText = event.clipboardData?.getData('text') || '';
    event.preventDefault();
    if (/^\d+$/.test(clipboardText)) {
      this.code.set(clipboardText);
      this.focusFirstEmptyInput();
      this.emitWhenComplete();
    }
  }

  private emitWhenComplete() {
    const code = this.code();
    if (code.length === this.length() && /^\d+$/.test(code)) {
      this.completed.emit(code);
    }
  }

  private focusFirstEmptyInput() {
    const input = this.inputs().find(input => input.nativeElement.value === '');
    input?.nativeElement?.focus();
    input?.nativeElement?.select();
  }

  private computeInputs(code: string, length: number): string[] {
    const inputs: string[] = [];

    for (let i = 0; i < length; i++) {
      const digit = code[i] || '';
      digit === ' ' ? inputs.push('') : inputs.push(digit);
    }

    return inputs;
  }
}
